/* eslint no-param-reassign: "error" */
import {
  useCallback,
  useEffect,
} from 'react';
import {
  Route,
  Routes,
  Navigate,
  useParams,
} from 'react-router';
import {
  shallowEqual,
  useDispatch,
  useSelector,
} from 'react-redux';
import {
  getStatus,
} from 'redux-resource';

import {
  coreActions,
  coreSelectors,
} from '@gymcloud/core';
import {
  usePageView,
} from 'web-hooks';

import {
  Spinner,
  NotFound,
  UserDetails,
  PersonalExercise,
} from 'web-components';

import EditProfile from './EditProfile';

const tabs = ['programs', 'workouts', 'exercises', 'videos', 'calendar', 'documents'];

const UsersPage = () => {
  const params = useParams();
  const id = params.id || 'me';

  const mapState = useCallback((state) => {
    const profile = coreSelectors.getProfile(state);
    return {
      readStatus: getStatus(
        state,
        [
          'clients.requests.fetchClient.status',
        ],
        true,
      ),
      profile,
      clientInfo: coreSelectors.getClientInfo(
        id === 'me' ? profile.id : +id,
      )(state),
    };
  }, [id]);

  const {
    readStatus,
    profile,
    clientInfo,
  } = useSelector(mapState, shallowEqual);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      coreActions.requestFetchClient(id),
    );
    dispatch(
      coreActions.requestDocuments(),
    );
  }, [id]);

  usePageView({
    eventKey: (id === 'me' && profile.is_pro) ? 'viewed_my_profile' : 'viewed_user_profile',
    attrs: {
      id: profile.id,
    },
    enabled: true,
  });

  return (
    <>
      {readStatus.succeeded && (
        <Routes>
          <Route
            index
            element={(
              <Navigate to="programs" replace />
            )}
          />
          <Route
            path="edit"
            element={(
              <EditProfile
                profileId={profile.id}
                clientInfo={clientInfo}
              />
            )}
          />
          <Route
            path="exercises/:id"
            element={(
              <PersonalExercise
                clientInfo={clientInfo}
              />
            )}
          />
          {tabs.map(tabName => (
            <Route
              key={tabName}
              path={tabName}
              element={(
                <UserDetails
                  id={id}
                  tabName={tabName}
                  clientInfo={clientInfo || {}}
                />
              )}
            />
          ))}
          <Route
            path="*"
            element={<NotFound />}
          />
        </Routes>
      )}

      {readStatus.pending && (
        <Spinner />
      )}

      {readStatus.failed && (
        <NotFound title="Something is wrong" />
      )}
    </>
  );
};

export default UsersPage;
